<ion-header>
  <ion-toolbar class="header-color">
    <ion-buttons slot="start">
      <ion-back-button></ion-back-button>
    </ion-buttons>
    <ion-title>Profile</ion-title>
  </ion-toolbar>
  <app-promoga-alert></app-promoga-alert>
</ion-header>

<ion-content>
  <ion-grid *ngIf="user">
    <ion-row>
      <ion-col>
        <div class="center m-auto">
          <img class="circularSquare" *ngIf="user.image" [src]="user | getImage:'profile'">
          <div *ngIf="!user.image">
            <ion-icon name="person-circle-outline" class="default-profile-icon"></ion-icon>
          </div>
          <h3 class="userProfileName">{{ user?.first_name }} {{ user?.last_name }}  <span *ngIf="fullName.length<30" style="display: inline-block">@ {{user?.username}}</span></h3>
          <h3 class="userProfileName"><span *ngIf="fullName.length>=30" style="display: inline-block">@ {{user?.username}}</span></h3>
          <h6 class="userProfileCert">{{user?.certs}}</h6>
          <h5 class="locationName">{{user?.city}}</h5>
          <span class="social-icon-btns">
            <div class="shareSocial">Share</div>
            <a (click)="shareFacebook()" target="_blank">
              <img src="assets/images/fb-icon.png" width="44" height="44" />
            </a>
            <a href="{{twitterShareUrl}}" target="_blank">
              <img src="assets/images/twitter-icon.png" width="44" height="44" />
            </a>
            <a href="mailto:?subject=Check out this Profile on Promoga: {{user.first_name}} {{user.last_name}}&body={{emailBody}}" target="_blank">
              <img src="assets/images/insta-icon.png" width="44" height="44"/>
            </a>
            <a (click)="copyUrlToClipboard()" target="_blank" style="cursor: pointer;" title="Copy Link">
              <img src="assets/images/ic-share-url.png" width="50" height="47" />
            </a>
          </span>
          <p class="info" *ngIf="!showMore">{{(user?.bio.length > 125) ? user.bio.substr(0,122) + "...": user.bio}}</p>
          <p class="info" *ngIf="showMore" >{{user.bio}}</p>
          <a class="bold" (click)="showMore = !showMore" *ngIf="user?.bio.length > 125">Show {{showMore ? 'less' : 'more'}}</a>
          <br />
          <br />
          <h2 class="activity" *ngIf="promotions.length > 0">Current Activity Listings</h2>
          <ion-grid *ngIf="promotions.length > 0">
            <ion-row *ngFor="let promo of promotions" class="profileActivity">
              <ion-col size='11' class="ion-no-padding">
                <div class="text-left activity-details">
                  <h6 (click)="showPromotionDetails(promo)" class="ion-no-padding">{{promo.classes.title}}</h6>
                  <p class="ion-no-padding ion-no-margin">{{promo.sessionsText}}</p>
                  <p class="ion-no-padding ion-no-margin" *ngIf="(getNextSessionTimestamp(promo) | date:'MMM dd') == (getLastClassDate(promo) | date:'MMM dd')">{{ convertTimeToUserTimezone(promo.start_date,promo) | date:'EEEE, dd MMM yyyy'}}</p>
                  <p class="ion-no-padding ion-no-margin" *ngIf="(getNextSessionTimestamp(promo) | date:'MMM dd') != (getLastClassDate(promo) | date:'MMM dd')">{{ convertTimeToUserTimezone(promo.start_date,promo) | date:'EEEE, dd MMM'}} - {{ convertTimeToUserTimezone(promo.end_date,promo) | date:'dd MMM yyyy'}}</p>
                </div>
              </ion-col>
            </ion-row>
          </ion-grid>
        </div>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
<ion-footer class="ion-no-border">
  <ion-toolbar>
    <ion-button expand="full" color="tertiary" (click)="serchByPromoter()" class="joinnowBtn">
      See All
    </ion-button>
  </ion-toolbar>
</ion-footer>
